/**
 * Wspólna paleta kolorów dla sal i instrumentów.
 *
 * Jedno miejsce zamiast dwóch list rozjeżdżających się przy każdym dodaniu
 * koloru. Wszystkie odcienie są przyciemnione na tyle, by biały tekst na nich
 * czytał się bez wysiłku — plakietki i bloki grafiku mają jasną treść.
 */

export interface PaletteColor {
  value: string
  label: string
}

export const PALETTE: PaletteColor[] = [
  { value: '#800020', label: 'Burgund' },
  { value: '#a8322c', label: 'Ceglasty' },
  { value: '#8a5300', label: 'Bursztyn' },
  { value: '#6b4423', label: 'Brąz' },
  { value: '#4f6b1f', label: 'Oliwka' },
  { value: '#1f6b52', label: 'Zieleń' },
  { value: '#0f6b6b', label: 'Morski' },
  { value: '#1c6f8c', label: 'Błękit' },
  { value: '#1f4f8f', label: 'Granat' },
  { value: '#5b3a8f', label: 'Fiolet' },
  { value: '#7a2f6b', label: 'Śliwka' },
  { value: '#a12d5f', label: 'Amarant' },
  { value: '#8c6a1f', label: 'Musztarda' },
  { value: '#454747', label: 'Grafit' },
]

export const PALETTE_VALUES = PALETTE.map((item) => item.value)

export const DEFAULT_COLOR = PALETTE[0].value

/**
 * Stały kolor przypisany identyfikatorowi.
 *
 * Używane na grafiku sali, gdzie każdy prowadzący ma mieć własny kolor. Wynik
 * musi być powtarzalny między odświeżeniami i między urządzeniami, więc kolor
 * wyliczamy z samego identyfikatora, a nie z kolejności na liście — ta zmienia
 * się przy każdym dodaniu nauczyciela.
 */
export function colorForId(id: string): string {
  let hash = 0
  for (let index = 0; index < id.length; index += 1) {
    // Mnożnik 31 to klasyczny rozrzut dla krótkich ciągów; `| 0` trzyma wynik
    // w zakresie 32-bitowym, żeby liczba nie uciekła w nieprecyzyjne zmiennoprzecinkowe.
    hash = (hash * 31 + id.charCodeAt(index)) | 0
  }
  return PALETTE_VALUES[Math.abs(hash) % PALETTE_VALUES.length]
}
